import { FieldType } from '@wix/wix-data-schema-types'
import { VIDEO_ROLE } from '@wix/wix-data-client-common-standalone'
import type { DataBindingComponentModel } from '@wix/data-binding-registry-sdk'

const { video, text, email, number, dateTime, date, address, stringArray } =
  FieldType

export default (): DataBindingComponentModel => ({
  componentName: 'Element_Name_VideoBox',
  isConnectGfppEnabled: true,
  supportsDefaultSelectedDataset: true,
  compactErrorPanel: false,
  panel: {
    height: 297,
    title: 'Connect_Panel_Title_Video_Box',
    helpId: '791a5719-fd58-469a-affa-79d767872a17',
  },
  sections: [
    {
      role: VIDEO_ROLE,
      bindings: [
        {
          title: 'Connect_Panel_Connect_VideoPlayer_Src_Label',
          prop: 'src',
          supportedFieldTypes: [video],
          defaultFieldType: video,
          supportsReferenceFields: true,
        },
        {
          title: 'connectVideoPlayerPanel.descriptionBinding.title',
          prop: 'description',
          supportedFieldTypes: [
            text,
            email,
            number,
            dateTime,
            date,
            address,
            stringArray,
          ],
          defaultFieldType: text,
          supportsReferenceFields: true,
          requiresPrimaryConnection: true,
        },
      ],
    },
  ],
})
